export default __webpack_public_path__ + "static/media/img1.e925d863.svg";